class EventDetail extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.applyButton = this.querySelector(".event-detail__apply-button");
    this.dateSelect = this.querySelector("#event_date");
    this.addressButton = this.querySelector(".event-detail__address-button");

    this.metaobject_id = this.getAttribute("metaobject_id");
    this.metaobject_handle = this.getAttribute("metaobject_handle");

    this.applyButton.disabled = true;
    this.dateSelect?.addEventListener("change", () => {
      if (this.dateSelect.value) {
        this.applyButton.disabled = false;
      } else {
        this.applyButton.disabled = true;
      }
    });

    this.addressButton?.addEventListener("click", (e) =>
      this.handleAddressClick(e),
    );

    this.applyButton.addEventListener("click", () => {
      const selectedDate = this.dateSelect.value;
      const formDateInput = document.querySelector("input[name='event_date']");
      const formIdInput = document.querySelector(
        "input[name='event_metaobject_shopify_id']",
      );
      const formHandleInput = document.querySelector(
        "input[name='event_metaobject_shopify_handle']",
      );

      if (formDateInput) {
        formDateInput.value = selectedDate;
      }

      if (formIdInput) {
        formIdInput.value = this.metaobject_id;
      }

      if (formHandleInput) {
        formHandleInput.value = this.metaobject_handle;
      }
    });
  }

  handleAddressClick(e) {
    e.preventDefault();
    let address = this.addressButton.textContent.trim();
    if (this.addressButton.getAttribute("data-query") != "") {
      address = this.addressButton.getAttribute("data-query");
    }
    this.openMap(address);
  }

  openMap(query) {
    const encodedQuery = encodeURIComponent(query);
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    let url;

    if (isIOS) {
      url = `maps://?q=${encodedQuery}`;
      // url = `https://maps.apple.com/?q=${encodedQuery}`;
    } else {
      url = `https://www.google.com/maps/search/?api=1&query=${encodedQuery}`;
    }

    window.open(url, "_blank");
  }

  disconnectedCallback() {
    // Cleanup on component removal
  }
}

customElements.define("event-detail", EventDetail);
